import { INBOX } from "./actions";
import initialState from "../../../../reducers/initialState";

const InboxReducer = (state = initialState, action) => {
  switch (action.type) {
    //initialState
    case INBOX.INBOX_MODAL_TOGGLE: {
      return {
        ...state,
        inboxModal: !state.inboxModal,
      };
    }

    case INBOX.INBOX_BADGE_UPDATE: {
      return {
        ...state,
        inboxBadge: action.data,
      };
    }
    case INBOX.MEMBER_MODAL_TOGGLE: {
      return {
        ...state,
        memberModal: !state.memberModal,
      };
    }
    case INBOX.UPDATE_POST_DETAILS: {
      return {
        ...state,
        postDetails: action.data,
      };
    }

    default:
      return state;
  }
};

export default InboxReducer;
